<!-- eslint-disable -->
<template>
    <b-popover :target="'popover-' + zona.id" triggers="hover focus">

        <template slot="title">{{ zona.name ?? zona.nombre }}</template>

        <template v-if="zona.esta_disponible">
            <div>
                {{ $t('mapa.disponible') }}
            </div>
            <div v-if="zona_id == zona.id">
                {{ $t('mapa.estas_aqui') }}
                <template v-if="occupied">
                    ({{ $t('mapa.ocupado') }})
                </template>
            </div>

            <span v-if="taquilla && (zona.aforo || zona.total_asientos)">
                {{ $t('mapa.aforo') }}: {{ zona.aforo ? zona.aforo : zona.total_asientos }}
            </span>

            <br v-if="zona.aforo || zona.total_asientos">

            <span v-if="zona.count_bloqueados">
                {{ $t('mapa.bloqueados') }}: {{ zona.count_bloqueados }}
            </span>

            <br v-if="zona.count_bloqueados">

            <span v-if="zona.sesion">
                {{ $t('mapa.en_sesion') }}: {{ zona.sesion }}
            </span>

            <br v-if="zona.sesion">

            <span v-if="zona.confirmados">
                {{ $t('mapa.confirmados') }}: {{ zona.confirmados }}
            </span>

            <br v-if="zona.confirmados">

            <span v-if="libres >= 0 && (taquilla || zona.with_seats != 0)">
                {{ $t('general.libres') }}: {{ libres }}
            </span>                 

            <template v-if="libres >= 0">
                <br>
                <br>
            </template>

            <template v-if="zona.precios?.length > 0">
                <div>{{ $t('mapa.precios_disponibles') }}</div>
    
                <ul>
                    <li v-for="precio in zona.precios" :key="precio.id">
                        {{precio.descripcion }} - {{ precio.precio | formatear_precio }}
                    </li>
                </ul>
            </template>
        </template>
        <template v-else>
            <template v-if="$route.name == 'back.events.sesion.bloquear-asientos' || $route.name == 'back.abonos.bloquear-asientos'">
                <span v-if="zona.aforo || zona.total_asientos">
                    {{ $t('mapa.aforo') }}: {{ zona.aforo ? zona.aforo : zona.total_asientos }}
                </span>

                <br v-if="zona.aforo || zona.total_asientos">

                <span v-if="zona.count_bloqueados">
                    {{ $t('mapa.bloqueados') }}: {{ zona.count_bloqueados }}
                </span>

                <br v-if="zona.count_bloqueados">

                <span v-if="libres >= 0 && (taquilla || zona.with_seats != 0)">
                    {{ $t('general.libres') }}: {{ libres }}
                </span>

                <br>
            </template>

            <template v-if="!config_precios">
                {{ $t('mapa.no_disponible') }}
            </template>

            <template v-if="this.$route.name == 'back.events.sesion.bloquear-asientos'">
                <div class="alert alert-warning" role="alert">
                    <b>{{ $t('mapa.no_precios') }}</b>
                </div>
            </template>
        </template>
    </b-popover>
</template>

<script>
    export default {
        props: ['zona', 'zona_id', 'libres', 'occupied', 'config_precios'],
        computed: {
            taquilla() {
                var path = this.$router.currentRoute.fullPath;
                return path.includes('admin');
            },
        }
    }
</script>
